const JobCard = ({ job, onClick }) => {
  const {
    company,
    logo,
    isNew,
    isFeatured,
    position,
    role,
    level,
    postedAt,
    contract,
    location,
    languages,
    tools,
  } = job;

  const tags = [role, level];

  if (tools) {
    tags.push(...tools);
  }

  if (languages) {
    tags.push(...languages);
  }

  return (
    // <div className="flex flex-col justify-between bg-white shadow-md my-5 mx-10 p-6 rounded-md border-teal-500 border-solid sm:flex-row">
    //   {/* company logo */}
    //   <img
    //     src={"https://img.freepik.com/free-icon/mac-os_318-10374.jpg"}
    //     alt="logo"
    //     className="-mt-11mb-4 w-25 h-20 sm:mt-0 sm:h-24 sm:my-0"
    //   />

    //   <div className="flex-flex-col-justify-between ml-4">
    //     {/* company name */}
    //     <h1 className="py-2 text-primary_dark_cyan text-lg flex items-center gap-2">
    //       {company}
    //       {isNew && (
    //         <span className="bg-primary rounded-full px-3 text-base text-white">
    //           New!
    //         </span>
    //       )}
    //       {isFeatured && (
    //         <span className="bg-gray rounded-xl px-3 text-base text-white">
    //           Featured
    //         </span>
    //       )}
    //     </h1>

    //     {/* job position */}
    //     <h1 className="text-xl font-bold cursor-pointer">{position}</h1>

    //     {/* job info */}
    //     <p className="flex items-center gap-2 text-black text-base">
    //       {postedAt} • {contract} • {location}
    //     </p>
    //   </div>
    //   {/* Job tags */}
    //   <div className="flex flex-wrap items-center mt-4 mx-4 pt-4 border-t border-gray border-solid sm:ml-auto sm:border-0 sm:pt-0">
    //     {tags.map((tag) => (
    //       <button className="text-white bg-primary p-2 rounded mr-4 mb-4 sm:mb-0">
    //         {tag}
    //       </button>
    //     ))}
    //   </div>
    // </div>

    <div
      class="group bg-white p-4 lg:p-8 verflow-hidden transition duration-300 transform border border-lightGray rounded shadow-sm hover:scale-105 group hover:shadow-xl cursor-pointer"
      onClick={onClick}
    >
      <div class="mb-3 text-right">
        <button class="text-gray transition-all duration-300 hover:scale-110 hover:text-red">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="h-6 w-6"
          >
            <path d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" />
          </svg>
        </button>
      </div>
      <div class="flex items-center gap-x-2">
        <img
          class="aspect-[2.5/2] w-16"
          src="data:image/png;base64,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"
        />
        <div>
          <h3 class="text-xl font-bold text-black">Apple</h3>
          <span class="text-xs text-black">New location, USA</span>
        </div>
      </div>
      <div class="my-4">
        <h3 class="text-2xl font-medium text-gray-200">UI/UX Designer</h3>
        <div class="text-sm font-medium">
          <span class="m-1 ml-0 inline-block text-primary">HTML</span>
          <span class="m-1 ml-0 inline-block text-primary">CSS</span>
          <span class="m-1 ml-0 inline-block text-primary">FIGMA</span>
          <span class="m-1 ml-0 inline-block text-primary">Ad. XD</span>
          <span class="m-1 ml-0 inline-block text-primary">Illustrator</span>
        </div>
        <div class="mt-2 text-sm text-gray-400">$60K - $100K per year</div>
      </div>
      <div class="flex items-center justify-between">
        <span class="text-sm font-medium text-gray-50">Full Time</span>
        <button
          type="submit"
          className="text-white bg-primary font-medium text-primary transition-all duration-300 group-hover:bg-secondary rounded-md text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        >
          Apply Now
        </button>
        {/* <a class="font-medium text-primary transition-all duration-300 group-hover:text-secondary">
            Apply Now
          </a> */}
      </div>
    </div>
  );
};

export default JobCard;
